var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-10 mx-auto"},[_c('QuizFront')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }